import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';

export type PrivateLandOwnership = {
  uuid: string;
  owner: string;
  address: string;
  taxAddress: string;
  lat: number;
  lng: number;
  acres: number;
  buildings: number;
  zoningType: string;
  zoningSubtype: string;
  femaFloodZone: string | null;
  femaFloodZoneSubtype: string | null;
  femaFloodZoneDataDate: string | null;
};

type UsePrivateLandOwnershipProps = {
  uuid: string;
};

type UsePrivateLandOwnership = Omit<
  UseQueryResult<PrivateLandOwnership, Error>,
  'data'
> & {
  privateLandOwnership?: PrivateLandOwnership;
};

export const usePrivateLandOwnership = (
  props: UsePrivateLandOwnershipProps,
): UsePrivateLandOwnership => {
  const { uuid } = props;

  const { data: privateLandOwnership, ...results } = useQuery({
    queryKey: ['private-land-ownership', uuid],
    queryFn: async () => {
      const response = await API.get<PrivateLandOwnership>(
        `land_ownership_gis/private/${uuid}`,
      );
      return response.data;
    },
    enabled: Boolean(uuid),
  });

  return { privateLandOwnership, ...results };
};
